import type { LeadStatus } from '@conversia/shared-types';
import type { Faceta } from './superfiltro';

/**
 * Las bandejas de Chats: la TEMPERATURA del lead (embudo) y «Atención» (alta A1 de la
 * auditoría): las conversaciones en WAITING_HUMAN, a quién se le debe respuesta YA. PURO.
 */
const ATENCION = '__ATTN';
export const PESTANAS: { valor: LeadStatus | '' | typeof ATENCION; etiqueta: string }[] = [
  { valor: '', etiqueta: 'Todas' },
  { valor: ATENCION, etiqueta: 'Atención' },
  { valor: 'CALIENTE', etiqueta: 'Caliente' },
  { valor: 'TIBIO', etiqueta: 'Tibio' },
  { valor: 'FRIO', etiqueta: 'Frío' },
  { valor: 'CERRADO', etiqueta: 'Cerrado' },
  { valor: 'NO_CERRADO', etiqueta: 'No cerrado' },
];

export const TIPOS_DE_CHAT: { value: 'all' | 'individual' | 'group'; label: string }[] = [
  { value: 'all', label: 'Todas' },
  { value: 'individual', label: 'Individuales' },
  { value: 'group', label: 'Grupos' },
];

/** Lo que la bandeja elegida le pide a la API. */
export function filtrosDePestana(valor: string): { leadStatus?: LeadStatus; status?: 'WAITING_HUMAN' } {
  if (valor === ATENCION) return { status: 'WAITING_HUMAN' };
  return valor ? { leadStatus: valor as LeadStatus } : {};
}

/** Las claves de la bandeja en la URL (`/conversations?bandeja=CALIENTE&canal=…`). */
export const FILTROS_DE_LA_BANDEJA = { bandeja: '', tipo: '', canal: '', buscar: '' };
/** Un valor raro en la URL no filtra en secreto: cae a «todas». */
export const VALIDOS_DE_LA_BANDEJA = { bandeja: PESTANAS.map((p) => p.valor), tipo: ['individual', 'group'] };

/** Las facetas del superfiltro de Chats: bandeja, tipo de chat y canal. PURO. */
export function facetasDeLaBandeja(canales: { id: string; nombre: string }[]): Faceta[] {
  return [
    { clave: 'bandeja', titulo: 'Bandeja', todas: 'Todas', opciones: PESTANAS.filter((p) => p.valor).map((p) => ({ valor: p.valor, etiqueta: p.etiqueta })) },
    { clave: 'tipo', titulo: 'Tipo', todas: 'Todas', opciones: TIPOS_DE_CHAT.filter((t) => t.value !== 'all').map((t) => ({ valor: t.value, etiqueta: t.label })) },
    ...(canales.length > 0 ? [{ clave: 'canal', titulo: 'Canal', opciones: canales.map((c) => ({ valor: c.id, etiqueta: c.nombre })) }] : []),
  ];
}
